import * as angular from "angular";
import {apsCommands} from "../../shared/dto/aps.commands";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

let requires = [HttpServiceName];

export interface RequalificationService {
  addRequalification(requalification: apsCommands.AddRequalification): any;
}

class RequalificationSvc implements RequalificationService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  addRequalification(requalification: apsCommands.AddRequalification): any {
    return this.httpService.post(Endpoints.REQUALIFICATION, requalification);
  }
}

export default angular
  .module('aps.services.requalification', requires)
  .service('requalificationService', RequalificationSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/requalification/requalification.service.ts